import { permissions } from 'components/Can/Permissions/Permissions';
import { PermissionNames } from 'components/Can/Permissions/Permissions.type';
import { useAppSelector } from 'redux/store';

export const useCheckPermission = (permission: PermissionNames): boolean => {
  const user = useAppSelector(state => state.authSlice.user);
  if (!user) return false;
  return permissions[permission].findIndex(item => item === user?.role) >= 0;
};
